import {farpittjonline} from "./Images/ProjectImages/ttjonline.png"

let Data = [
    {
        "id": 1,
        "image": "https://ria-project-images.netlify.app/src/ttj.jpg",
        "title": "Stutory",
        "discription": "A platform for placing students of the Fergana Polytechnic Institute in an online dormitory",
        "likes": 1,
        "link": "http://ttj-farpi.stutory.uz/",
        "data": {
            "updated": "17.04.2023",
            "modified": "17.04.2023"
        },
        "used": {
            "name1": "HTML",
            "name2": "CSS",
            "name3": "JavaScript"
        }
    },
    {
        "id": 2,
        "image": "https://ria-project-images.netlify.app/src/vakansiya.jpg",
        "title": "Vakansiya",
        "discription": "lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "likes": 0,
        "link": "https://ria-vakansiya.netlify.app",
        "data": {
            "updated": "31.03.2023",
            "modified": "1.04.2023"
        },
        "used": {
            "name1": "React",
            "name2": "CSS",
            "name3": "JavaScript"
        }
    },
    {
        "id": 3,
        "image": "https://ria-project-images.netlify.app/src/chatapp.jpg",
        "title": "Chat App",
        "discription": "lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "likes": 0,
        "link": "https://new-chat-application.netlify.app/",
        "data": {
            "updated": "31.03.2023",
            "modified": "1.04.2023"
        },
        "used": {
            "name1": "React",
            "name2": "CSS",
            "name3": "JavaScript"
        }
    },
    {
        "id": 4,
        "image": "https://ria-project-images.netlify.app/src/konstitutsiya.jpg",
        "title": "Konstitutsiya",
        "discription": "lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "likes": 0,
        "link": "https://ria-konstitutsiya.netlify.app",
        "data": {
            "updated": "13.05.2023",
            "modified": "19.05.2023"
        },
        "used": {
            "name1": "React",
            "name2": "CSS",
            "name3": "JavaScript"
        }
    },
    {
        "id": 5,
        "image": "https://ria-project-images.netlify.app/src/setuz.jpg",
        "title": "Sets.uz",
        "discription": "lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "likes": 0,
        "link": "https://setsuz.netlify.app/",
        "data": {
            "updated": "20.05.2023",
            "modified": "20.05.2023"
        },
        "used": {
            "name1": "HTML",
            "name2": "CSS",
            "name3": "JavaScript"
        }
    },
    {
        "id": 6,
        "image": "https://ria-project-images.netlify.app/src/tatuff.jpg",
        "title": "Sets.uz",
        "discription": "A platform for placing students of the Fergana Information Technology university in an online dormitory",
        "likes": 0,
        "link": "http://ttj-tatuff.stutory.uz/",
        "data": {
            "updated": "15.08.2023",
            "modified": "19.08.2023"
        },
        "used": {
            "name1": "HTML",
            "name2": "CSS",
            "name3": "JavaScript"
        }
    },
    {
        "id": 7,
        "image": "https://ria-project-images.netlify.app/src/alehson.png",
        "title": "alehson.uz",
        "discription": "Yordamga muhtojlarga yordam berish uchun web platforma",
        "likes": 0,
        "link": "https://65544e45ac7b9959d77f5f80--ria-alehson.netlify.app/",
        "data": {
            "updated": "15.11.2023",
            "modified": "29.11.2023"
        },
        "used": {
            "name1": "HTML",
            "name2": "CSS",
            "name3": "JavaScript",
            "name3": "React JS"
        }
    },
    
    
]





export default Data
